import { useMemo as n, Fragment as e, createElement as i, useRef as o, useState as t, useCallback as r } from "react";
import { Container as l, useDimensions as u, SvgWrapper as a, ResponsiveWrapper as d, getRelativeCursor as s } from "@nivo/core";
import { scaleLinear as c } from "d3-scale";
import { Delaunay as h } from "d3-delaunay";
import { jsx as f, jsxs as v, Fragment as p } from "react/jsx-runtime";
function m() {
  return m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }
    return n;
  }, m.apply(this, arguments);
}
var y = {
    xDomain: [0, 1],
    yDomain: [0, 1],
    layers: ["links", "cells", "points", "bounds"],
    enableLinks: !1,
    linkLineWidth: 1,
    linkLineColor: "#bbbbbb",
    enableCells: !0,
    cellLineWidth: 2,
    cellLineColor: "#000000",
    enablePoints: !0,
    pointSize: 4,
    pointColor: "#666666",
    role: "img"
  },
  g = function (n) {
    return "function" == typeof n ? n : function (e) {
      return e[n];
    };
  },
  b = function (n) {
    var e = n.points,
      i = n.x,
      o = void 0 === i ? "x" : i,
      t = n.y,
      r = void 0 === t ? "y" : t,
      l = g(o),
      u = g(r);
    return e.map(function (n) {
      return [l(n), u(n)];
    });
  },
  k = function (n) {
    var e = n.points,
      i = n.width,
      o = n.height,
      t = n.debug,
      r = h.from(e),
      l = t ? r.voronoi([0, 0, i, o]) : void 0;
    return {
      delaunay: r,
      voronoi: l
    };
  },
  x = function (e) {
    var i = e.points,
      o = e.x,
      t = e.y,
      r = e.width,
      l = e.height,
      u = e.debug,
      a = n(function () {
        return b({
          points: i,
          x: o,
          y: t
        });
      }, [i, o, t]);
    return n(function () {
      return k({
        points: a,
        width: r,
        height: l,
        debug: u
      });
    }, [a, r, l, u]);
  },
  C = function (e) {
    var i = e.data,
      o = e.width,
      t = e.height,
      r = e.xDomain,
      l = e.yDomain,
      u = n(function () {
        return c().domain(r).range([0, o]);
      }, [r, o]),
      a = n(function () {
        return c().domain(l).range([0, t]);
      }, [l, t]),
      d = n(function () {
        return i.map(function (n) {
          return {
            x: u(n.x),
            y: a(n.y),
            data: n
          };
        });
      }, [i, u, a]);
    return n(function () {
      var n = h.from(d.map(function (n) {
          return [n.x, n.y];
        })),
        e = n.voronoi([0, 0, o, t]);
      return {
        points: d,
        delaunay: n,
        voronoi: e
      };
    }, [d, o, t]);
  },
  L = function (e) {
    var i = e.points,
      o = e.delaunay,
      t = e.voronoi;
    return n(function () {
      return {
        points: i,
        delaunay: o,
        voronoi: t
      };
    }, [i, o, t]);
  },
  w = ["theme"],
  W = function (n) {
    var o = n.data,
      t = n.width,
      r = n.height,
      l = n.margin,
      d = n.layers,
      s = void 0 === d ? y.layers : d,
      c = n.xDomain,
      h = void 0 === c ? y.xDomain : c,
      v = n.yDomain,
      p = void 0 === v ? y.yDomain : v,
      m = n.enableLinks,
      g = void 0 === m ? y.enableLinks : m,
      b = n.linkLineWidth,
      k = void 0 === b ? y.linkLineWidth : b,
      x = n.linkLineColor,
      w = void 0 === x ? y.linkLineColor : x,
      W = n.enableCells,
      D = void 0 === W ? y.enableCells : W,
      M = n.cellLineWidth,
      O = void 0 === M ? y.cellLineWidth : M,
      P = n.cellLineColor,
      j = void 0 === P ? y.cellLineColor : P,
      S = n.enablePoints,
      z = void 0 === S ? y.enableCells : S,
      A = n.pointSize,
      E = void 0 === A ? y.pointSize : A,
      H = n.pointColor,
      B = void 0 === H ? y.pointColor : H,
      F = n.role,
      I = void 0 === F ? y.role : F,
      q = u(t, r, l),
      G = q.outerWidth,
      J = q.outerHeight,
      K = q.margin,
      N = q.innerWidth,
      Q = q.innerHeight,
      R = C({
        data: o,
        width: N,
        height: Q,
        xDomain: h,
        yDomain: p
      }),
      T = R.points,
      U = R.delaunay,
      V = R.voronoi,
      X = {
        links: null,
        cells: null,
        points: null,
        bounds: null
      };
    g && s.includes("links") && (X.links = f("path", {
      stroke: w,
      strokeWidth: k,
      fill: "none",
      d: U.render()
    }, "links")), D && s.includes("cells") && (X.cells = f("path", {
      d: V.render(),
      fill: "none",
      stroke: j,
      strokeWidth: O
    }, "cells")), z && s.includes("points") && (X.points = f("path", {
      stroke: "none",
      fill: B,
      d: U.renderPoints(void 0, E / 2)
    }, "points")), s.includes("bounds") && (X.bounds = f("path", {
      fill: "none",
      stroke: j,
      strokeWidth: O,
      d: V.renderBounds()
    }, "bounds"));
    var Y = L({
      points: T,
      delaunay: U,
      voronoi: V
    });
    return f(a, {
      width: G,
      height: J,
      margin: K,
      role: I,
      children: s.map(function (n, o) {
        return void 0 !== X[n] ? X[n] : "function" == typeof n ? f(e, {
          children: i(n, Y)
        }, o) : null;
      })
    });
  },
  D = function (n) {
    var e = n.theme,
      i = function (n, e) {
        if (null == n) return {};
        var i,
          o,
          t = {},
          r = Object.keys(n);
        for (o = 0; o < r.length; o++) i = r[o], e.indexOf(i) >= 0 || (t[i] = n[i]);
        return t;
      }(n, w);
    return f(l, {
      isInteractive: !1,
      animate: !1,
      theme: e,
      children: f(W, m({}, i))
    });
  },
  M = function (n) {
    return f(d, {
      children: function (e) {
        var i = e.width,
          o = e.height;
        return f(D, m({
          width: i,
          height: o
        }, n));
      }
    });
  },
  O = function (e) {
    var i = e.nodes,
      l = e.width,
      u = e.height,
      a = e.x,
      d = e.y,
      c = e.onMouseEnter,
      h = e.onMouseMove,
      m = e.onMouseLeave,
      y = e.onClick,
      g = e.debug,
      b = o(null),
      k = t(null),
      C = k[0],
      L = k[1],
      w = x({
        points: i,
        x: a,
        y: d,
        width: l,
        height: u,
        debug: g
      }),
      W = w.delaunay,
      D = w.voronoi,
      M = n(function () {
        if (g && D) return D.render();
      }, [g, D]),
      O = r(function (n) {
        if (!b.current) return [null, null];
        var e = s(b.current, n),
          o = e[0],
          t = e[1],
          r = W.find(o, t);
        return [r, void 0 !== r ? i[r] : null];
      }, [b, W]),
      P = r(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == c || c(o, n));
      }, [O, L, c]),
      j = r(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == h || h(o, n));
      }, [O, L, h]),
      S = r(function (n) {
        if (L(null), m) {
          var e = void 0;
          null !== C && (e = i[C]), e && m(e, n);
        }
      }, [L, C, m, i]),
      z = r(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == y || y(o, n));
      }, [O, L, y]);
    return v("g", {
      ref: b,
      children: [g && D && v(p, {
        children: [f("path", {
          d: M,
          stroke: "red",
          strokeWidth: 1,
          opacity: .75
        }), null !== C && f("path", {
          fill: "pink",
          opacity: .35,
          d: D.renderCell(C)
        })]
      }), f("rect", {
        width: l,
        height: u,
        fill: "red",
        opacity: 0,
        style: {
          cursor: "auto"
        },
        onMouseEnter: P,
        onMouseMove: j,
        onMouseLeave: S,
        onClick: z
      })]
    });
  },
  P = function (n, e) {
    n.save(), n.globalAlpha = .75, n.beginPath(), e.render(n), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
  },
  j = function (n, e, i) {
    n.save(), n.globalAlpha = .35, n.beginPath(), e.renderCell(i, n), n.fillStyle = "red", n.fill(), n.restore();
  };
export { O as Mesh, M as ResponsiveVoronoi, D as Voronoi, k as computeMesh, b as computeMeshPoints, y as defaultVoronoiProps, j as renderVoronoiCellToCanvas, P as renderVoronoiToCanvas, C as useVoronoi, L as useVoronoiLayerContext, x as useVoronoiMesh };